import Icon from "@ant-design/icons";

const TennisCourtSvg = () => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="#31493C"
      stroke="none"
    >
      <path
        d="M1060 4652 c-17 -14 -32 -59 -71 -227 -27 -116 -65 -279 -85 -362
l-36 -153 -94 0 c-147 0 -139 17 -147 -320 -12 -465 -10 -543 12 -571 19 -24
17 -29 -270 -1234 -158 -666 -288 -1225 -289 -1242 0 -20 8 -41 20 -53 20 -20
33 -20 2459 -20 l2440 0 20 26 c12 15 21 33 21 41 0 8 -129 564 -286 1235
l-285 1220 22 24 22 24 -7 401 c-4 270 -10 408 -18 422 -21 40 -39 46 -140 47
l-96 0 -36 153 c-20 83 -58 246 -85 362 -39 168 -54 213 -71 227 -21 17 -98
18 -1500 18 -1402 0 -1479 -1 -1500 -18z m240 -149 c0 -5 -25 -140 -56 -300
l-57 -293 -78 0 -77 0 13 58 c71 301 125 534 125 538 0 7 130 4 130 -3z m2364
-10 c2 -10 12 -58 21 -108 9 -49 18 -98 21 -107 5 -17 -54 -18 -1146 -18
-1092 0 -1151 1 -1146 18 3 9 12 58 21 107 9 50 19 98 21 108 5 16 66 17 1104
17 1038 0 1099 -1 1104 -17z m286 13 c0 -4 54 -237 125 -538 l13 -58 -77 0
-78 0 -57 293 c-31 160 -56 295 -56 300 0 7 130 10 130 3z m-1470 -501 l0 -95
-569 0 -569 0 8 38 c5 20 13 63 20 95 l11 57 550 0 549 0 0 -95z m1270 38 c7
-32 15 -75 20 -95 l8 -38 -569 0 -569 0 0 95 0 95 549 0 550 0 11 -57z m-2690
-403 l0 -110 -140 0 -140 0 0 110 0 110 140 0 140 0 0 -110z m480 0 l0 -110
-160 0 -160 0 0 110 0 110 160 0 160 0 0 -110z m470 0 l0 -110 -160 0 -160 0
0 110 0 110 160 0 160 0 0 -110z m470 0 l0 -110 -160 0 -160 0 0 110 0 110
160 0 160 0 0 -110z m480 0 l0 -110 -160 0 -160 0 0 110 0 110 160 0 160 0 0
-110z m470 0 l0 -110 -160 0 -160 0 0 110 0 110 160 0 160 0 0 -110z m480 -5
l0 -115 -160 0 -160 0 0 115 0 115 160 0 160 0 0 -115z m430 0 l0 -115 -140 0
-140 0 0 115 0 115 140 0 140 0 0 -115z m-3280 -385 l0 -120 -140 0 -140 0 0
120 0 120 140 0 140 0 0 -120z m475 0 l0 -115 -157 -3 -158 -3 0 121 0 121
158 -3 157 -3 0 -115z m475 0 l0 -120 -160 0 -160 0 0 120 0 120 160 0 160 0
0 -120z m470 0 l0 -121 -157 3 -158 3 -3 104 c-1 58 0 111 2 118 4 10 41 13
161 13 l155 0 0 -120z m475 0 l0 -115 -157 -3 -158 -3 0 121 0 121 158 -3 157
-3 0 -115z m480 0 l0 -115 -157 -3 -158 -3 0 121 0 121 158 -3 157 -3 0 -115z
m475 0 l0 -121 -157 3 -158 3 -3 118 -3 117 161 0 160 0 0 -120z m440 0 l0
-121 -142 3 -143 3 -3 104 c-1 58 0 111 2 118 4 10 39 13 146 13 l140 0 0
-120z m-3342 -282 c-3 -7 -103 -541 -223 -1185 l-219 -1173 -153 0 c-95 0
-153 4 -153 10 0 11 538 2327 545 2348 3 8 34 12 106 12 77 0 100 -3 97 -12z
m1472 -698 l0 -710 -791 0 -791 0 5 23 c3 12 62 319 132 682 69 363 128 672
131 688 l6 27 654 0 654 0 0 -710z m1474 683 c3 -16 62 -325 131 -688 70 -363
129 -670 132 -682 l5 -23 -791 0 -791 0 0 710 0 710 654 0 654 0 6 -27z m629
-1150 c153 -648 277 -1181 277 -1185 0 -5 -69 -8 -153 -8 l-153 0 -222 1173
c-123 644 -223 1178 -222 1185 0 9 26 12 98 12 l97 0 278 -1177z m-270 -776
c38 -204 71 -382 74 -395 l5 -22 -1836 0 -1836 0 5 23 c3 12 34 182 70 377 36
195 68 363 71 373 5 16 94 17 1692 17 l1687 0 68 -373z"
      />
    </g>
  </svg>
);

const TennisCourtIcon = (props) => (
  <Icon component={TennisCourtSvg} {...props} />
);

export default TennisCourtIcon;
